import {FC} from 'react'
import {FormikProps, getIn} from 'formik'
import clsx from 'clsx'

export interface FormikErrorsProps {
  formik: FormikProps<any>
  fieldKey: string
  fieldLabel?: string
  /**
   * Optional 'field touched' check on whether to show error
   */
  touched?: boolean
}

const FormikErrors: FC<FormikErrorsProps> = (props: FormikErrorsProps) => {
  const errorValues = getIn(props.formik.errors, props.fieldKey)
  const touchedValues = getIn(props.formik.touched, props.fieldKey)

  const isErrorAnArray = Array.isArray(errorValues)
  const hasErrorValuesContainsObject =
    isErrorAnArray &&
    errorValues.some((value: any) => {
      return typeof value == 'object'
    })

  return (
    <>
      {(touchedValues || props.touched === true) && errorValues ? (
        <div className='text-danger px-6'>
          {/* Not Array */}
          {!isErrorAnArray && (
            <div
              dangerouslySetInnerHTML={{
                __html: props.fieldLabel ? String(errorValues).replace(props.fieldKey, props.fieldLabel) : String(errorValues),
              }}
            ></div>
          )}
          {/* Is Array */}
          {isErrorAnArray && (
            <ul>
              {hasErrorValuesContainsObject &&
                (errorValues as any).map((error: any, index: number) => {
                  if (error) {
                    let properties = Object.keys(error)
                    let errorElement: JSX.Element[] = []

                    properties.forEach((property) => {
                      errorElement.push(<span key={`${property}-${index}`} dangerouslySetInnerHTML={{__html: error[property]}}></span>)
                    })

                    return (
                      <li key={index} className={clsx({'mt-2': index != 0})}>
                        {errorElement}
                      </li>
                    )
                  }
                })}
              {!hasErrorValuesContainsObject &&
                (errorValues as any).map((error: any, index: number) => {
                  return (
                    <li key={index} className={clsx({'mt-2': index != 0})}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: error,
                        }}
                      ></span>
                    </li>
                  )
                })}
            </ul>
          )}
        </div>
      ) : null}
    </>
  )
}

export default FormikErrors
